export enum LocationStatus {
  Closed,
  Busy,
  Open,
}
